import { actions as adminActions } from 'store/actions/admin';
import u from 'updeep';

const initialState = {
    users: [],
    teams: [],
    models: [],
    jobs: [],
    previews: [],
    organizations: [],
    clients: [],
    selectedTeamData: {},
    selectedOrganizationData: {},
    isLoading: false,
    isOrgLoading: false,
    pagination: {},
    creatorsPagination: {},
    organizationsPagination: {},
    clientsPagination: {},
};

const adminReducer = (state = initialState, action) => {
    switch(action.type) {
        case adminActions.GET_USERS_ADMIN:
            return u({
                users: action.payload.users,
                pagination: {
                    page: action.payload.page,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.totalCount,
                    totalPages: action.payload.totalPages,
                },
            }, state);
        case adminActions.GET_TEAMS_ADMIN:
            return u({
                teams: action.payload.teams,
                pagination: {
                    page: action.payload.page,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.teamsCount,
                    totalPages: Math.ceil(action.payload.teamsCount / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_PIPELINE_ADMIN:
            return u({
                pipelines: action.payload.instances || [],
                queues: action.payload.queues || [],
                pagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.instanceCount,
                    totalPages: Math.ceil(action.payload.instanceCount / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_CREATORS_ADMIN:
            return u({
                creators: action.payload.creators,
                creatorsPagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.creatorsCount,
                    totalPages: Math.ceil(action.payload.creatorsCount / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_JOBS_ADMIN:
            return u({
                jobs: action.payload.jobs ?? [],
                jobTypes: action.payload.types ?? [],
                jobStatuses: action.payload.statuses ?? [],
                filteredCount: action.payload.filteredTotalJobs,
                pagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.filteredTotalJobs,
                    totalPages: Math.ceil(action.payload.filteredTotalJobs / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_PREVIEWS_ADMIN:
            return u({
                previews: action.payload.previews ?? [],
                previewTypes: action.payload.types ?? [],
                previewClients: action.payload.clients ?? [],
                filteredCount: action.payload.filteredTotalPreviews,
                pagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.filteredTotalPreviews,
                    totalPages: Math.ceil(action.payload.filteredTotalPreviews / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_MODELS_ADMIN:
            return u({
                models: action.payload.models,
                filteredCount: action.payload.filteredTotalModels,
                categoryCount: action.payload.categoryCounts,
                tags: action.payload.tags,
                pagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.filteredTotalModels,
                    totalPages: Math.ceil(action.payload.filteredTotalModels / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_ORG_MODELS_ADMIN:
            return u({
                models: action.payload.models,
                filteredCount: action.payload.filteredTotalModels,
                catgeoryCount: action.payload.categoryCounts,
                tags: action.payload.tags,
                pagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.filteredTotalModels,
                    totalPages: Math.ceil(action.payload.filteredTotalModels / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_ORGANIZATIONS_ADMIN:
            return u({
                organizations: action.payload.organizations,
                organizationsPagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.filterCount,
                    totalPages: Math.ceil(action.payload.totalOrgCount / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_OAUTH_CLIENTS_ADMIN:
            return u({
                clients: action.payload.clients,
                clientsPagination: {
                    page: action.payload.currentPage,
                    pageSize: action.payload.pageSize,
                    totalCount: action.payload.clientCount,
                    totalPages: Math.ceil(action.payload.clientCount / action.payload.pageSize),
                },
            }, state);
        case adminActions.GET_TEAM_ID_ADMIN:
            return u({ selectedTeamData: action.payload }, state);
        case adminActions.GET_ORGANIZATION_ID_ADMIN:
            return u({ selectedOrganizationData: action.payload }, state);
        case adminActions.DELETE_TEAM_MEMBER_ADMIN:
            return u({ selectedTeamData: action.payload }, state);
        case adminActions.SET_IS_LOADING:
            return u({ isLoading: action.payload }, state);
        case adminActions.SET_ORG_LOADING:
            return u({ isOrgLoading: action.payload }, state);
        case adminActions.SET_OAUTH_LOADING:
            return u({ isOauthLoading: action.payload }, state);
        case adminActions.CLEAR_ADMIN_MODELS:
            return u({ models: [], pagination: {} }, state);
        default:
            return state;
    }
};

export { adminReducer };
